import PartsFormatter from './PartsFormatter';
import SimpleFormatter from './SimpleFormatter';
import SpecialNumberLocaleFormatter from './SpecialNumberLocaleFormatter';

const browserDoesNotSupportFormatToParts = (formatter) =>
  typeof formatter.formatToParts !== 'function';

const createFormatter = (currency, locale, minimumFractionDigits) =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits,
  });

const BaseMoneyFormatter = (
  { locale, numberLocale, minimumFractionDigits },
  currency,
  styled
) => {
  const formatter = createFormatter(currency, locale, minimumFractionDigits);
  if (
    (!styled && !numberLocale) ||
    browserDoesNotSupportFormatToParts(formatter)
  ) {
    return SimpleFormatter(formatter);
  }
  const partsFormatter = PartsFormatter(formatter);
  if (!numberLocale) {
    return partsFormatter;
  }
  return SpecialNumberLocaleFormatter(
    partsFormatter,
    PartsFormatter(
      createFormatter(currency, numberLocale, minimumFractionDigits)
    ),
    styled
  );
};

const MoneyFormatter = ({ locale, rounded, currency, styled }) => {
  const formatter = BaseMoneyFormatter(
    rounded ? { ...locale, minimumFractionDigits: 0 } : locale,
    currency,
    styled
  );
  return {
    format(amount) {
      const parsedAmount = rounded ? Math.ceil(amount) : amount;
      return formatter.format(parsedAmount);
    },
  };
};

export default MoneyFormatter;
